import React, { useMemo, useState } from 'react';
import './NTVOutdoorHotspotStyle.scss';
import { TRAVEL_TIMES, HOTSPOT_RENDER_ORDER } from './constants';

const newstarLogo =
  process.env.PUBLIC_URL + '/assets/images/logo/white-logo-newstar.webp';

const DEFAULT_HEIGHT = 140;

const NTVOutdoorHotspotStyle = ({ scene, height = 1, onClick, media }) => {
  const effectiveHeight = DEFAULT_HEIGHT;

  // Render order based on HOTSPOT_RENDER_ORDER index
  const hotspotId = scene?._id || media?._id;

  const renderOrderIndex = HOTSPOT_RENDER_ORDER.indexOf(hotspotId);
  const zIndex = renderOrderIndex >= 0 ? renderOrderIndex + 1 : 0;

  const title = useMemo(() => {
    if (scene?._id === '68d12769ddcbe92b6b39ad9e') return 'NEWSTAR';
    return media?.title || scene?.title || 'NEWSTAR';
  }, [media, scene]);

  const [isHovered, setIsHovered] = useState(true);

  const darkStyle = (isHovered && scene?.amenitiesScene) || media;

  const travelTimeSubtitle =
    TRAVEL_TIMES[scene?._id] || TRAVEL_TIMES[media?._id];
  const displaySubtitle = travelTimeSubtitle;

  const mainHotspot = scene?._id === '68d12769ddcbe92b6b39ad9e';

  return (
    <div className="ntv-outdoor--hotspot-style" style={{ zIndex }}>
      <div
        className="ntv-outdoor--hotspot-style--container"
        style={{
          height: `${mainHotspot ? 50 : effectiveHeight * (media?.height || height)}px`,
        }}
      >
        <div
          className={`ntv-outdoor--hotspot-style--line ${scene?._id || media?._id}`}
        ></div>
        <div
          className={`ntv-outdoor--hotspot-style--title ${
            darkStyle ? 'is-dark' : ''
          } ${mainHotspot ? 'main-hotspot' : ''}`}
          onClick={() => {
            if (!scene?.amenitiesScene) return onClick();
          }}
          onMouseEnter={() => setIsHovered(false)}
          onMouseLeave={() => setIsHovered(true)}
        >
          {!mainHotspot && (
            <div className="ntv-outdoor--hotspot-style--title-inner">
              <span className="ntv-outdoor--hotspot-style--icon"></span>
              <div className="ntv-outdoor--hotspot-style--title-texts">
                <div className="ntv-outdoor--hotspot-style--title-text">
                  {title}
                </div>
                {displaySubtitle && (
                  <div className="ntv-outdoor--hotspot-style--subtitle">
                    {/* {displaySubtitle} */}
                  </div>
                )}
              </div>
            </div>
          )}
          {mainHotspot && (
            <div
              className="ntv-outdoor--hotspot-style--title-inner"
              style={{ cursor: 'pointer' }}
            >
              <div className="ntv-outdoor--hotspot-style--title-texts-inner">
                <div className="ntv-outdoor--hotspot-style--title-text">
                  <img
                    src={newstarLogo}
                    alt="Newstar"
                    className="ntv-outdoor--hotspot-style--title-text--logo"
                  />
                </div>

                {displaySubtitle && (
                  <div className="ntv-outdoor--hotspot-style--subtitle">
                    {/* {displaySubtitle} */}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NTVOutdoorHotspotStyle;
